var indentation_default = {
  "indentZero": "UGHSE",
  "indentOne": "H2oJW",
  "indentTwo": "huUks",
  "indentThree": "_0TIT2",
  "indentFour": "z5Gd2",
  "indentFive": "DZCn8",
  "indentSix": "dHcuj"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
